import { all, call, put, takeLatest } from 'redux-saga/effects'
import VoiceActions, { VoiceTypes } from 'Redux/VoiceRedux'

// Get Voices
export function* getVoices(api, action) {
  try {
    const resp = yield call(api.getVoices)

    if (resp.ok && resp.data?.voices) {
      yield put(VoiceActions.voicesListSuccess(resp.data.voices))
    } else {
      // API call failed - let UI handle fallback with DEFAULT_VOICES
      const error = resp.data?.error || 'Failed to fetch voices from API'
      console.warn(`[VoiceSagas] ${error}`)
      yield put(VoiceActions.voicesListFailure(error))
    }
  } catch (error) {
    const errorMsg = error.message || 'Network error fetching voices'
    console.error('[VoiceSagas] Error fetching voices:', error)
    // Let UI handle fallback with DEFAULT_VOICES
    yield put(VoiceActions.voicesListFailure(errorMsg))
  }
}

// Watcher saga
export default function* voiceSaga(api) {
  yield all([
    takeLatest(VoiceTypes.VOICES_LIST_REQUEST, getVoices, api),
  ])
}
